<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import ConfigUtil from "@/utils/config.js";
import { resetPageScroll } from "@/utils/utils.js";

export default {
  data() {
    return {
      infoTimer: null,
      infoDialogVisible: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
    // ...其他 computed
  },
  watch: {
    "userInfo.realname": {
      handler(newVal) {
        if (!newVal) {
          // this.startInfoTimer();
        } else {
          this.clearInfoTimer();
        }
      },
      immediate: true,
    },
    "$route.path": {
      handler(newVal) {
        if (newVal == "/user/base-info") {
          this.clearInfoTimer();
        }
        // 路由变化时确保页面滚动到顶部
        this.$nextTick(() => {
          resetPageScroll(false); // 使用即时滚动
        });
      },
      immediate: true,
    },
    "isLogin": {
      handler(newVal) {
        if (newVal) {
          this.$store.dispatch('GET_USER_INFO');
          // 获取当前路径
          const currentPath = this.$route.path;
        }
      },
      immediate: true
    }
  },
  mounted() {
    ConfigUtil.initConfig();
    this.changeLink()
  }
  ,
  methods: {
    changeLink() {
      // 判断是否为移动端或H5端
         // 判断是否为移动端或H5端
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      // 检查当前是否已经在H5链接上，避免重复跳转
      const currentUrl = window.location.href;
      const h5Link = this.$api.H5link;

      // 如果当前已经在H5页面，则不执行跳转
      if (currentUrl.includes(h5Link)) {
        return;
      }

      // 如果是移动设备，则跳转到H5页面
      if (isMobile) {
        window.location.href = h5Link;
      }
    },
    clearInfoTimer() {
      if (this.infoTimer) {
        clearTimeout(this.infoTimer);
        this.infoTimer = null;
      }
    },
  },
};
</script>
<style>
@import url("assets/css/theme.css");
</style>
